import cx from 'classnames'
import { type ReactNode } from 'react'

interface ButtonProps {
  size: 'large' | 'small'
  disabled?: boolean
  isVisuallyDisabled?: boolean
  onClick?: () => void
  className?: string
  children: ReactNode
}

const Button = ({
  size,
  disabled,
  isVisuallyDisabled,
  onClick,
  className,
  children,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cx(
        'flex items-center transition-all justify-center px-8 py-3 text-sm font-medium text-center border-[1px] rounded-full leading-[1.2] border-black bg-black text-white hover:opacity-80 disabled:opacity-50',
        {
          'cursor-pointer': !disabled && !isVisuallyDisabled,
          'opacity-20 cursor-default': disabled || isVisuallyDisabled,
          'px-4 py-2': size === 'small',
          'px-8 py-4.5': size === 'large',
        },
        className,
      )}
    >
      {children}
    </button>
  )
}

export default Button
